import React from 'react';

var escapePattern = function escapePattern(pattern) {
  return pattern.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
};

var ignoreSpecialCharacters = function ignoreSpecialCharacters(pattern) {
  return pattern.replace(/[^\w\s\']/gi, '');
};

var Highlight = function Highlight(_ref) {
  var pattern = _ref.pattern,
      caseSensitive = _ref.caseSensitive,
      ignoreSpecial = _ref.ignoreSpecial,
      children = _ref.children;

  var highlightedSegments = function highlightedSegments(text) {
    if (ignoreSpecial) pattern = ignoreSpecialCharacters(pattern);
    var regex = new RegExp(escapePattern(pattern), caseSensitive ? 'g' : 'gi');
    var segments = [];
    var match = regex.exec(text);

    while (match) {
      var start = match.index;
      var end = regex.lastIndex;
      if (end > start) segments.push({
        start: start,
        end: end,
        highlight: true
      });
      if (match.index === regex.lastIndex) regex.lastIndex += 1;
      match = regex.exec(text);
    }

    return segments;
  };

  var getSegments = function getSegments(text, highlighted) {
    var segments = [];

    var addSegment = function addSegment(start, end, highlight) {
      if (end - start > 0) {
        segments.push({
          start: start,
          end: end,
          highlight: highlight
        });
      }
    };

    if (highlighted.length === 0) {
      addSegment(0, text.length, false);
    } else {
      var lastIndex = 0;
      highlighted.forEach(function (segment) {
        addSegment(lastIndex, segment.start, false);
        addSegment(segment.start, segment.end, true);
        lastIndex = segment.end;
      });
      addSegment(lastIndex, text.length, false);
    }

    return segments;
  };

  var renderChildren = function renderChildren(node) {
    if (Array.isArray(node)) {
      return node.map(renderChildren);
    } else if (typeof node === 'string') {
      return getSegments(node, highlightedSegments(node)).map(function (_ref2) {
        var start = _ref2.start,
            end = _ref2.end,
            highlight = _ref2.highlight;
        var text = node.slice(start, end);

        if (highlight) {
          return (
            /*#__PURE__*/
            React.createElement("mark", {
              className: "p-0"
            }, text)
          );
        }

        return text;
      });
    } else if (
    /*#__PURE__*/
    React.isValidElement(node)) {
      return (
        /*#__PURE__*/
        React.cloneElement(node, [], renderChildren(node.props.children))
      );
    }

    return node || null;
  };

  return renderChildren(children);
};

export default Highlight;